import { createContext, useContext } from "react";

export const STRINGS = {
  it: {
    hudTitle: "Sei Porte",
    level: "Livello",
    time: "Tempo",
    timeLeft: "Gas tra",
    key: "Chiave",
    room: "Stanza",
    soundOn: "Attiva audio",
    soundOff: "Disattiva audio",
    pause: "Pausa",
    leaderboard: "Classifica",
    eyebrow: "Un rompicapo senza fine",
    title: "Il Labirinto delle Sei Porte",
    playerName: "Nome giocatore",
    namePlaceholder: "Inserisci il tuo nome...",
    difficulty: "Difficoltà",
    language: "Lingua",
    enter: "Entra nel labirinto",
    levels: { facile: "Facile", normale: "Normale", incubo: "Incubo" },
    controls: { move: "muoviti", space: "Spazio", jump: "salta", enter: "entra", down: "scendi", chalk: "segno col gesso", pause: "pausa" },
    gas: { eyebrow: "Tempo scaduto", title: "Il gas ti ha preso", text: "Le bocchette si sono aperte e la stanza si è riempita di gas. Il labirinto si rimescola: tutto ricomincia." },
    exit: { eyebrow: "Uscita trovata", title: "Sei evaso", text: "Hai spezzato il ciclo. Questa volta." },
    rank: "Posizione",
    saveError: "Impossibile salvare il punteggio.",
    newMaze: "Nuovo labirinto",
    restart: "Ricomincia",
    changeLevel: "Cambia livello",
    enterHint: "Premi Invio per ricominciare",
    boardError: "Classifica non disponibile.",
    loading: "Caricamento...",
    empty: "Nessuno è ancora evaso. Sii il primo.",
    name: "Nome",
    close: "Chiudi",
    paused: "In pausa",
    resume: "Riprendi",
    backToMenu: "Torna al menu",
    rotate: "Ruota il telefono in orizzontale per giocare meglio",
    footer: "Ogni stanza è uguale. Ricorda i tuoi passi.",
    touch: { left: "Sinistra", right: "Destra", down: "Scendi", chalk: "Gesso", enter: "Entra", jump: "Salta" },
    install: "Installa",
    iosHelp: ["Tocca ", "Condividi", " in Safari, poi ", "Aggiungi alla schermata Home", "."],
    doorPrompt: { touch: "entra \u00b7 gesso", keys: "W / \u2191 \u00b7 E gesso" },
    anon: "Anonimo",
    login: "Accedi con Google",
    loginHint: "Serve solo per entrare in classifica",
    logout: "Esci",
    loginToSave: "Accedi con Google per salvare questo tempo in classifica.",
    loginAndSave: "Accedi e salva",
    savedPending: "Tempo salvato in classifica",
    deleteAccount: "Elimina account",
    deleteConfirm: "Eliminare account e punteggi?",
    yes: "Sì, elimina",
    no: "Annulla",
    privacy: "Privacy",
  },
  en: {
    hudTitle: "Six Doors",
    level: "Level",
    time: "Time",
    timeLeft: "Gas in",
    key: "Key",
    room: "Room",
    soundOn: "Unmute",
    soundOff: "Mute",
    pause: "Pause",
    leaderboard: "Leaderboard",
    eyebrow: "An endless puzzle",
    title: "The Maze of Six Doors",
    playerName: "Player name",
    namePlaceholder: "Enter your name...",
    difficulty: "Difficulty",
    language: "Language",
    enter: "Enter the maze",
    levels: { facile: "Easy", normale: "Normal", incubo: "Nightmare" },
    controls: { move: "move", space: "Space", jump: "jump", enter: "enter", down: "drop", chalk: "chalk mark", pause: "pause" },
    gas: { eyebrow: "Time's up", title: "The gas got you", text: "The vents opened and the room filled with gas. The maze reshuffles: everything starts over." },
    exit: { eyebrow: "Exit found", title: "You escaped", text: "You broke the loop. This time." },
    rank: "Rank",
    saveError: "Could not save your score.",
    newMaze: "New maze",
    restart: "Try again",
    changeLevel: "Change level",
    enterHint: "Press Enter to restart",
    boardError: "Leaderboard unavailable.",
    loading: "Loading...",
    empty: "Nobody has escaped yet. Be the first.",
    name: "Name",
    close: "Close",
    paused: "Paused",
    resume: "Resume",
    backToMenu: "Back to menu",
    rotate: "Rotate your phone to landscape for a better experience",
    footer: "Every room is the same. Remember your steps.",
    touch: { left: "Left", right: "Right", down: "Drop", chalk: "Chalk", enter: "Enter", jump: "Jump" },
    install: "Install",
    iosHelp: ["Tap ", "Share", " in Safari, then ", "Add to Home Screen", "."],
    doorPrompt: { touch: "enter \u00b7 chalk", keys: "W / \u2191 \u00b7 E chalk" },
    anon: "Anonymous",
    login: "Sign in with Google",
    loginHint: "Only needed for the leaderboard",
    logout: "Sign out",
    loginToSave: "Sign in with Google to save this time to the leaderboard.",
    loginAndSave: "Sign in and save",
    savedPending: "Time saved to the leaderboard",
    deleteAccount: "Delete account",
    deleteConfirm: "Delete account and scores?",
    yes: "Yes, delete",
    no: "Cancel",
    privacy: "Privacy",
  },
};

export const LangContext = createContext("it");
export const useT = () => STRINGS[useContext(LangContext)];

export const initialLang = () => {
  const saved = localStorage.getItem("labirinto-lang");
  if (STRINGS[saved]) return saved;
  return navigator.language?.toLowerCase().startsWith("it") ? "it" : "en";
};
